import { render, staticRenderFns } from "./SaleAmtReport.vue?vue&type=template&id=8f66b952"
import script from "./SaleAmtReport.vue?vue&type=script&lang=js"
export * from "./SaleAmtReport.vue?vue&type=script&lang=js"
import style0 from "./SaleAmtReport.vue?vue&type=style&index=0&id=8f66b952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports